import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export const LogoMark = ({ className = "w-11 h-11", large = false }) => (
  <img src={large ? "/images/logo.webp" : "/images/logo-256.png"} alt="Masal Sanat Akademi logosu" className={`rounded-full object-contain ${className}`} />
);

export function Logo({ light = false, to = "/" }) {
  const { site } = useSite();
  return (
    <Link to={to} data-testid="site-logo" className="flex items-center gap-3 group">
      {site?.logo_url ? (
        <img src={site.logo_url} alt="Masal Sanat Akademi logosu" className="h-14 w-auto" />
      ) : (
        <LogoMark className="w-14 h-14 transition-transform duration-500 group-hover:rotate-6" />
      )}
      <span className="leading-tight">
        <span className={`block font-heading font-extrabold text-lg ${light ? "text-white" : "text-navy"}`}>Masal</span>
        <span className={`block text-[11px] tracking-[0.2em] uppercase font-semibold ${light ? "text-bej" : "text-navy/70"}`}>
          Sanat Akademi
        </span>
      </span>
    </Link>
  );
}
